import { lisbonTrip } from '../../../../test/data/cmsTrip';
import {
  IMTFactsResponse,
  IMTTripPhaseCities,
  IMTTripPhaseType,
  IMTTripReservingDetails
} from '../apiTypes';

export async function fetchCityFacts(
  // eslint-disable-next-line no-unused-vars
  erpId: number
): Promise<IMTFactsResponse | undefined> {
  return {
    cityFacts: {
      population: 123,
      timeZone: 'Europe/Lisbon'
    },
    countryFacts: {
      currencyCode: 'EUR'
    }
  };
}

export async function fetchTripPhaseCities(): Promise<IMTTripPhaseCities[]> {
  return [
    {
      phaseType: IMTTripPhaseType.FLIGHT,
      departureCity: {
        name: 'Helsinki'
      },
      arrivalCity: {
        name: 'Lissabon'
      }
    },
    {
      phaseType: IMTTripPhaseType.HOTEL,
      departureCity: {
        name: 'Lissabon'
      },
      arrivalCity: {
        name: 'Lissabon'
      }
    },
    {
      phaseType: IMTTripPhaseType.FLIGHT,
      departureCity: {
        name: 'Lissabon'
      },
      arrivalCity: {
        name: 'Helsinki'
      }
    }
  ];
}

export async function fetchTripReservingDetails(
  tripId: number
): Promise<IMTTripReservingDetails | undefined> {
  // TODO: We should control what mock returns in E2E test file - not here, for example like this:
  // cypress test-file:
  // 1. etchTripReservingDetailsMock.returns({..})
  // 2. actual test code
  // We are a bit hurry now, so just hard code some logic here.
  if (tripId === lisbonTrip.fields.erpTripId) {
    return {
      tripId,
      date: '2019-08-01',
      pricePerPassenger: 123,
      durationAsNights: 1,
      extendableHotelPhaseNights: 1
    };
  }
  return undefined;
}
